import React from 'react';
import { componentService } from 'js/services/component.service';

export const Promotions = React.lazy(() => import(/* webpackChunkName: "promotions" */ './Promotions'));

componentService.registerPageComponents({ promotions: Promotions });
